<template>
    <div class="page" :style="{'--styleColor': actInfo.color, backgroundImage:'url('+ actInfo.bg_other +')'}">
        <PageLoading v-if="loading"></PageLoading>
        <TipsWechat ref="child" v-if="platform==2"></TipsWechat>
        <TipsZonglan ref="child" v-if="platform==3"></TipsZonglan>
        <TipsHbrb ref="child" v-if="platform==4"></TipsHbrb>

        <div class="mainBox">
            <!-- 排行榜标题：两侧横线 + 主题色 -->

            <div class="rankTitle">
                <span class="rankTitle__line"></span>
                <span class="rankTitle__text">活动榜单</span>
                <span class="rankTitle__line"></span>
            </div>
            <div class="rankTip" v-if="cacheTtlText && rankList.length > 0">（榜单数据每{{ cacheTtlText }}更新）</div>
            <!-- 排行榜 tab：个人排名 + 联动菜单各层级(别名) + 其他可排名字段 -->
            <van-tabs v-model="activeField" @change="onFieldChange" v-if="rankTabs.length > 0">
                <van-tab v-for="t in rankTabs" :key="t.name" :title="t.title" :name="t.name"></van-tab>
            </van-tabs>

            <!-- 分组选择（按菜单项分别排名 / 单选分值榜） -->
            <div class="groupBar" v-if="!isSingleList && groups.length > 0">
                <span
                    v-for="g in groups"
                    :key="g.key"
                    class="groupTag"
                    :class="{ active: currentKey === String(g.key) }"
                    @click="loadRank(g.key)"
                >{{ g.name }}({{ g.count }})</span>
            </div>

            <!-- 榜单 -->
            <van-cell-group v-if="rankList.length > 0">
                <van-cell v-for="(item, idx) in rankList" :key="isNameMode ? item.key : item.markField">
                    <template #title>
                        <div class="rankTitleRow">
                            <img v-if="item.rank === 1" class="rankNoImg" src="@/assets/images/rank1.png" alt="" />
                            <img v-else-if="item.rank === 2" class="rankNoImg" src="@/assets/images/rank2.png" alt="" />
                            <img v-else-if="item.rank === 3" class="rankNoImg" src="@/assets/images/rank3.png" alt="" />
                            <span v-else class="rankNo">{{ item.rank }}</span>
                            <span class="rankName">{{ nameText(item) }}</span>
                        </div>
                    </template>
                    <template #default>
                        <span class="rankScore" v-if="isCount">{{ item.count }} 人</span>
                        <span class="rankScore" v-else>{{ scoreText(item) }} 分</span>
                    </template>
                </van-cell>
            </van-cell-group>

            <van-empty v-if="!loading && rankList.length === 0" description="暂无排行数据" />
        </div>

        <NavBox :actInfo="actInfo"></NavBox>
        <LotteryBox v-if="actInfo.dis_btn && (actInfo.dis_btn.includes('cj'))" :lotteryid="Number(actInfo.bind_lotteryid)"></LotteryBox>
    </div>
</template>

<script>
import { reqLearnInfo, reqRank } from '@/api/learn.js'
import PageLoading from '@/components/PageLoading.vue'
import NavBox from '@/components/NavBox.vue'
import TipsWechat from '@/components/TipsWechat.vue'
import TipsZonglan from '@/components/TipsZonglan.vue'
import TipsHbrb from '@/components/TipsHbrb.vue'
import LotteryBox from '@/components/LotteryBox.vue'

export default {
    name: 'learnRank',
    mixins: [],
    components: { PageLoading, TipsWechat, TipsZonglan, TipsHbrb, NavBox, LotteryBox },
    props: {},
    data () {
        return {
            platform: 0,
            loading: false,
            learnid: 0,
            token: "",
            accessid: '',
            openid: '',
            accountId: '',
            uniqueId: '',
            actInfo: "",
            // 可排名字段
            rankFields: [],
            activeField: "",
            // 分组概要
            groups: [],
            // 榜单
            rankList: [],
            // 当前分组 key
            currentKey: '',
            // 个人排行依据（后端返回）
            personalMetric: 'score_learn',
            // 榜单缓存时间（秒）
            cacheTtl: 0,
        }
    },
    computed: {
        // 统一 tab 列表：个人排名 + 联动菜单各层级(别名) + 其他可排名字段
        rankTabs() {
            const tabs = [{ name: '__personal__', title: '个人榜单', type: 'personal' }]
            this.rankFields.forEach(f => {
                if (!f || f.field_name === '__personal__') return
                if (f.type === 'region') {
                    this.getLevels(f).forEach(lv => {
                        tabs.push({
                            name: f.field_name + '__level__' + lv,
                            title: this.levelTitle(f, lv),
                            field_name: f.field_name,
                            level: lv,
                            type: 'region'
                        })
                    })
                } else if (f.type === 'radio' && (f.rank_mode || 'user') !== 'menu' && f.rank_metric !== 'count') {
                    // 单选「按菜单项分别排名」：每个选项一个 tab，直接展示该选项用户榜
                    const options = Array.isArray(f.options) ? f.options : []
                    options.forEach((o, i) => {
                        const label = (o && (o.label || o.name)) || ''
                        const val = (o && o.value !== undefined && o.value !== null && o.value !== '') ? o.value : label
                        tabs.push({
                            name: f.field_name + '__option__' + i,
                            title: (label || String(val)) + '榜单',
                            field_name: f.field_name,
                            level: 0,
                            type: 'radio_option',
                            value_key: String(label)
                        })
                    })
                } else {
                    tabs.push({
                        name: f.field_name,
                        title: f.title || (f.label + '榜单'),
                        field_name: f.field_name,
                        level: 0,
                        type: f.type
                    })
                }
            })
            return tabs
        },
        // 当前 tab
        currentTab() {
            return this.rankTabs.find(t => t.name === this.activeField) || this.rankTabs[0] || null
        },
        // 当前排名字段
        currentField() {
            if (!this.currentTab || this.currentTab.type === 'personal') return null
            return this.rankFields.find(f => f.field_name === this.currentTab.field_name) || null
        },
        // 当前层级（联动菜单字段）
        currentLevel() {
            return this.currentTab && this.currentTab.level ? this.currentTab.level : 0
        },
        // 排行依据：count=学习用户量统计榜，其余为分值榜
        rankMetric() {
            const f = this.currentField
            if (!f) return this.personalMetric || 'score_learn'
            return f.rank_metric || 'score_learn'
        },
        // 是否为「学习用户量」统计榜
        isCount() {
            return this.rankMetric === 'count'
        },
        // 是否为「对菜单项排名」模式（联动菜单且 rank_mode=menu）
        isMenuMode() {
            const f = this.currentField
            if (!f) return false
            return f.rank_mode === 'menu'
        },
        // 是否为单列表榜单（无分组：对菜单项排名 或 学习用户量统计）
        isSingleList() {
            return this.isMenuMode || this.isCount
        },
        // 榜单项展示「名称」（菜单项/选项名）还是「用户名」
        isNameMode() {
            return this.isSingleList
        },
        // 榜单缓存时间文案（秒 -> 分钟/小时）
        cacheTtlText() {
            const s = Number(this.cacheTtl) || 0;
            if (s <= 0) return '';
            if (s % 3600 === 0) return (s / 3600) + '小时';
            if (s % 60 === 0) return (s / 60) + '分钟';
            return s + '秒';
        }
    },
    watch: {},
    created () {
        this.platform = this.$route.query.platform;
        this.learnid = this.$route.query.learnid;
        this.token = this.$store.state.token;
        this.openid = this.$store.state.openid;
        this.accessid = this.$store.state.accessid;
        this.accountId = this.$store.state.accountId;
        this.uniqueId = this.$store.state.uniqueId;
        this.actInfo = this.$store.state.actInfo;
    },
    mounted () {
        this.loadRankFields();
    },
    methods: {
        // 构造身份参数
        buildParams(extra) {
            let data = {
                platform: this.platform,
                learnid: this.learnid,
            };
            if (this.platform == 2) {
                data.accessid = this.accessid;
                data.openid = this.openid;
            }
            if (this.platform == 3 || this.platform == 4) {
                data.account_id = this.accountId;
                data.unique_id = this.uniqueId;
            }
            if (this.platform == 1 || this.platform == 5) {
                data.token = this.token;
            }
            return Object.assign(data, extra || {});
        },
        // 加载可排名字段（个人排名 + 按 is_rank 过滤的自定义字段）
        loadRankFields() {
            this.loading = true;
            reqLearnInfo({ platform: this.platform, learnid: this.learnid }).then(res => {
                if (res.code == 200) {
                    const formFields = res.data.form_fields || [];
                    const grouped = formFields.filter(f => {
                        if (Number(f.is_rank) !== 1) return false;
                        return f.type === 'region' || f.type === 'radio';
                    });
                    this.rankFields = [
                        { field_name: '__personal__', label: '个人榜单', title: '个人榜单', type: 'personal' },
                        ...grouped
                    ];
                    this.activeField = '__personal__';
                    this.loadPersonal();
                } else {
                    this.loading = false;
                    this.$toast({ icon: 'warning-o', message: res.msg });
                }
            }).catch(() => {
                this.loading = false;
            });
        },
        // 切换 tab
        onFieldChange() {
            this.currentKey = '';
            this.groups = [];
            if (!this.currentTab) return;
            if (this.currentTab.type === 'personal') {
                this.loadPersonal();
            } else if (this.currentTab.type === 'radio_option') {
                // 单选「按菜单项分别排名」：直接加载该选项榜单
                this.loadRank(this.currentTab.value_key);
            } else if (this.isSingleList) {
                this.loadStat();
            } else {
                this.loadGroups();
            }
        },
        // 层级标题（优先别名，无别名用默认二级/三级/四级）
        levelTitle(f, lv) {
            const names = (f && f.rank_level_names) || {};
            if (names[lv]) return names[lv];
            const m = { 2: '二级', 3: '三级', 4: '四级' };
            return m[lv] || (lv + '级');
        },
        // 提取字段的展示层级（升序）
        getLevels(f) {
            const lv = f.rank_levels;
            const arr = Array.isArray(lv) ? lv.map(Number) : String(lv || '').split(',').map(Number);
            return arr.filter(n => n >= 2 && n <= 4).sort((a, b) => a - b);
        },
        // 分值榜数值（个人/字段分值类）
        scoreText(item) {
            const m = this.rankMetric;
            if (m === 'count') return item.count || 0;
            // 对菜单项排名：聚合值在 value 字段
            if (this.isMenuMode) {
                const v = item.value;
                return (v === undefined || v === null || v === '') ? 0 : v;
            }
            const val = item[m];
            return (val === undefined || val === null || val === '') ? 0 : val;
        },
        // 榜单显示名称（序号 + 排行名 + 分值中的「排行名」）
        nameText(item) {
            const n = this.isNameMode ? item.name : (item.nickname || item.username || item.markField);
            return n || '';
        },
        // 加载个人排名（全局榜单，无分组）
        loadPersonal() {
            this.loading = true;
            const params = this.buildParams({ field_name: '__personal__' });
            reqRank(params).then(res => {
                if (res.code == 200) {
                    this.groups = [];
                    this.rankList = res.data.list || [];
                    this.currentKey = '';
                    this.personalMetric = (res.data && res.data.rank_metric) || 'score_learn';
                    this.cacheTtl = res.data.cache_ttl || 0;
                    this.loading = false;
                } else {
                    this.loading = false;
                    this.$toast({ icon: 'warning-o', message: res.msg });
                }
            }).catch(() => {
                this.loading = false;
            });
        },
        // 加载分组概要（不传 value_key）
        loadGroups() {
            this.loading = true;
            const extra = { field_name: this.currentTab.field_name };
            if (this.currentLevel > 0) extra.level = this.currentLevel;
            const params = this.buildParams(extra);
            reqRank(params).then(res => {
                if (res.code == 200) {
                    this.groups = res.data.groups || [];
                    this.rankList = [];
                    this.currentKey = '';
                    this.cacheTtl = res.data.cache_ttl || 0;
                    this.loading = false;
                    if (this.groups.length > 0) {
                        this.loadRank(this.groups[0].key);
                    }
                } else {
                    this.loading = false;
                    this.$toast({ icon: 'warning-o', message: res.msg });
                }
            }).catch(() => {
                this.loading = false;
            });
        },
        // 加载指定分组榜单
        loadRank(valueKey) {
            this.loading = true;
            const extra = { field_name: this.currentTab.field_name, value_key: valueKey };
            if (this.currentLevel > 0) extra.level = this.currentLevel;
            const params = this.buildParams(extra);
            reqRank(params).then(res => {
                if (res.code == 200) {
                    this.rankList = res.data.list || [];
                    this.currentKey = String(valueKey);
                    this.cacheTtl = res.data.cache_ttl || 0;
                    this.loading = false;
                } else {
                    this.loading = false;
                    this.$toast({ icon: 'warning-o', message: res.msg });
                }
            }).catch(() => {
                this.loading = false;
            });
        },
        // 加载单列表榜单（学习用户量统计 / 对菜单项排名）
        loadStat() {
            this.loading = true;
            const params = this.buildParams({ field_name: this.currentTab.field_name, level: this.currentLevel });
            reqRank(params).then(res => {
                if (res.code == 200) {
                    this.groups = [];
                    this.rankList = res.data.list || [];
                    this.currentKey = '';
                    this.cacheTtl = res.data.cache_ttl || 0;
                    this.loading = false;
                } else {
                    this.loading = false;
                    this.$toast({ icon: 'warning-o', message: res.msg });
                }
            }).catch(() => {
                this.loading = false;
            });
        },
    },
}
</script>

<style lang="scss" scoped>
.page{
  width: 750px;
  min-height: 1366px;
  font-size: 30px;
  background-repeat: no-repeat;
  background-size: contain;
  .mainBox{
    width: 700px;
    min-height:400px;
    position: absolute;
    left: 50%; transform: translateX(-50%);
    top: 150px;
    background: #fff;
    border-radius: 20px;
    padding: 20px;
    padding-bottom: 100px;
    .rankTitle{
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 30px 0;
        .rankTitle__line{
            flex: 1;
            flex: none; width: 250px; height: 3px;
            background: var(--styleColor);
            opacity: 0.4;
        }
        .rankTitle__text{
            padding: 0 25px;
            font-size: 34px;
            font-weight: bold;
            color: var(--styleColor);
            white-space: nowrap;
        }
    }
    .groupBar{
      display: flex;
      flex-wrap: wrap;
      gap: 15px;
      margin: 20px 0;
      .groupTag{
        padding: 8px 20px;
        background: #f5f5f5;
        border-radius: 30px;
        font-size: 24px;
        color: #666;
        &.active{
          background: var(--styleColor);
          color: #fff;
        }
      }
    }
    .rankTitleRow{
      display: flex;
      align-items: center;
      min-width: 0;
    }
    .rankNoImg{
      flex: none;
      width: 30px;
      padding: 0px 13px;
      height: auto;
      margin-right: 12px;
    }
    .rankNo{
      flex: none;
      width: 50px;
      text-align: center;
      margin-right: 15px;
      color: #999;
      &.top{ color: #f74434; font-weight: bold; }
    }
    .rankName{
      flex: 1;
      min-width: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: #333;
    }
    .rankScore{
      flex: none;
      white-space: nowrap;
      color: var(--styleColor);
      font-weight: bold;
    }
    .rankTip{
      margin-top: 20px;
      text-align: center;
      font-size: 20px;
      color: #999;
    }
  }
}
</style>
